import { gspx } from '@rsos/gainsight';

export const trackHistoricToggle = (
  showHistoricLocations: boolean,
  irpVersion?: unknown,
) => {
  if (showHistoricLocations) {
    gspx.trackCustomEvent('Data HistoricalLocationsToggle', {
      irpVersion,
      name: `Toggle historic locations on to off`,
      Category: 'Google Map',
      'Launched date': new Date(),
    });
  } else {
    gspx.trackCustomEvent('Data HistoricalLocationsToggle', {
      irpVersion,
      name: `Toggle historic locations off to on`,
      Category: 'Google Map',
      'Launched date': new Date(),
    });
  }
};
